const replacePolishCharsWithLatinChars = (value) => {
    if (typeof value !== 'string') {
        return ''
    }
    return value.replace(/Ą/g, 'A').replace(/ą/g, 'a')
        .replace(/Ć/g, 'C').replace(/ć/g, 'c')
        .replace(/Ę/g, 'E').replace(/ę/g, 'e')
        .replace(/Ł/g, 'L').replace(/ł/g, 'l')
        .replace(/Ń/g, 'N').replace(/ń/g, 'n')
        .replace(/Ó/g, 'O').replace(/ó/g, 'o')
        .replace(/Ś/g, 'S').replace(/ś/g, 's')
        .replace(/[ŻŹ]/g, 'Z').replace(/[żź]/g, 'z')
}

const sanitizeString = (value) => {
    if (typeof value !== 'string') {
        return ''
    }
    return value.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
}

export default {
    replacePolishCharsWithLatinChars,
    sanitizeString
}
